import { NotificationBar } from "@similarweb/ui-components";
import type { ComponentType } from "react";
import { Component } from "react";
import { connect } from "react-redux";

import { updateNotificationBarHeight } from "../../../actions/notificationBarActions";

export interface INotificationItem {
    id: string;
    text?: string;
    customComponent?: any;
    onClose?: () => {};
}

interface INotificationBarContainer {
    notificationList: [INotificationItem];
    updateNotificationBarHeight: (height: number) => void;
}

class NotificationBarContainer extends Component<INotificationBarContainer, any> {
    protected containerDiv;
    constructor(props) {
        super(props);
    }

    public componentDidUpdate() {
        this.props.updateNotificationBarHeight(this.containerDiv.clientHeight);
    }

    public render() {
        return (
            <div
                ref={(div) => {
                    this.containerDiv = div;
                }}
            >
                {this.props.notificationList
                    ? this.props.notificationList.map((notification) => {
                          const CustomComponent = notification.customComponent;
                          return CustomComponent ? (
                              <CustomComponent
                                  key={notification.id}
                                  {...notification}
                              />
                          ) : (
                              <NotificationBar
                                  key={notification.id}
                                  onClose={notification.onClose}
                              >
                                  {notification.text}
                              </NotificationBar>
                          );
                      })
                    : null}
            </div>
        );
    }
}

function mapStateToProps({ common }) {
    const notificationList = common.notificationList;
    return {
        notificationList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateNotificationBarHeight: (height) => {
            dispatch(updateNotificationBarHeight(height));
        },
    };
}
const connected = connect(mapStateToProps, mapDispatchToProps)(NotificationBarContainer as ComponentType);
export default connected;
